import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/projects/$projectId/site/')({
  beforeLoad: ({ params }) => {
    throw redirect({ to: '/projects/$projectId/site/today', params, replace: true });
  },
});
